const SecurityUtils = {
  sanitizeHTML: function (inputHtml) {
    // to build custom logic to sanitize the html content in future
    return inputHtml;
  },
  allowedTagsWithAttrs: {
    span: { class: "match-text" }, // Allow <span> with 'class' and 'match-text' (only "_blank" is allowed)
  },
  sanitizeHTMLForHighlight: function (inputHtml) {
    if (!inputHtml) return inputHtml;
    const map = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#039;",
    };

    const tagRegex = /<\/?([a-z][a-z0-9]*)\b([^>]*)>/gi;
    const attrRegex = /([a-z0-9-]+)(?:\s*=\s*(['"])(.*?)\2)?/gi;
    const allowedTagsWithAttrsAndValues = SecurityUtils.allowedTagsWithAttrs;
    // Function to escape characters
    const escapeHTML = (str) => str.replace(/[&<>"']/g, (m) => map[m]);
    // Sanitize function
    return inputHtml.replace(tagRegex, (tag, tagName, tagAttributes) => {
      const isClosingTag = tag.startsWith("</");
      tagName = tagName.toLowerCase();

      // Check if the tag is allowed
      if (allowedTagsWithAttrsAndValues.hasOwnProperty(tagName)) {
        if (isClosingTag) {
          return `</${tagName}>`;
        }
        const allowedAttrs = allowedTagsWithAttrsAndValues[tagName];
        const attrs = [];

        // Process each attribute
        tagAttributes.replace(attrRegex, (fullMatch, attrName, quote, attrValue) => {
          attrName = attrName.toLowerCase();
          if (allowedAttrs.hasOwnProperty(attrName)) {
            const allowedValues = allowedAttrs[attrName];

            // Check if the attribute value is allowed or no value restriction
            if (allowedValues === true || allowedValues.includes(attrValue)) {
              attrs.push(`${attrName}="${escapeHTML(attrValue || "")}"`);
            }
          }
        });

        const sanitizedAttributes = attrs.length ? " " + attrs.join(" ") : "";
        return `<${tagName}${sanitizedAttributes}>`;
      }

      // If the tag is not allowed, escape it
      return escapeHTML(tag);
    });
  },
  sanitizeText: function (inputText) {
    const div = document.createElement("div");
    div.appendChild(document.createTextNode(inputText));
    return div.innerHTML;
  },
  sanitizeUrl: function (url) {
    if (url) {
      return url.replace(/[^-A-Za-z0-9+&@#/%?=~_|!:,.;()]/i, "");
    } else {
      return "";
    }
  },
  hasHtmlInContent: function (str) {
    return /<(?=.*? .*?\/ ?>|br|hr|input|!--|wbr)[a-z]+.*?>|<([a-z]+).*?<\/\1>/i.test(str);
  },
  stripHtml(html: string): string {
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent?.trim() ?? "";
  },
  openInNewTab(routeHref: string) {
    window.open(routeHref, "_blank", "noreferrer,noopener");
  },
};

export default SecurityUtils;
